<script>
export default {
    name: "InfoCardsEmptyItem"
}
</script>

<template>
    <div class="hidden lg:block rounded-2xl opacity-50 border bg-grayBg border-grayBg p-5 w-full h-full"></div>
</template>

<style scoped lang="scss">

</style>
